import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { rootReducer } from './rootReducer';
export class StoreKeeper {
    public static store: any;
}

export const store = createStore(rootReducer, applyMiddleware(thunk));
StoreKeeper.store = store;
